// src/pages/Solicitacoes/components/StatusChip.jsx
import React from 'react';
import {Box} from '@mui/material';
import statusColors from './statusColors';

export default function StatusChip({status}) {
    return (
        <Box
            sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                bgcolor: statusColors[status],
                mx: 'auto',
            }}
        />
    );
}
